import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';


const ComputerAndTechnology = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/explore.jpg"} alt="Explore Habib University Library" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Explore Library</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/collaborative-working-and-learning-spaces" className='nav-link'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/computer-and-technology" className='nav-link active'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/printing-scanning-and-photocopying" className='nav-link'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/library-services" className='nav-link'>
                                    Library Services
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/maker-space" className='nav-link '>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/learningspaces/equipment-space.jpg"} alt="" />
                    <h6>Computers and Technology</h6>
                    <p>The Library Information Commons has made 30 state-of-the-art, all-in-one desktop computers available, equipped with essential productivity software and high-speed Wi-Fi internet connections. The computers are available for use on the ground and first floor. Patrons who bring their own laptops or digital devices can also access the Wi-Fi system by contacting the Help Desk on the ground floor.</p>
                    {/* <h6>MAC Computers</h6> */}
                    {/* <p>Six state-of-the-art Macintosh computers are available for multimedia publishing and processing on the first-floor library.</p> */}
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}
export default ComputerAndTechnology;